(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/assets/javascripts/views/pages/prolongation-page.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/assets/javascripts/views/pages/prolongation-page.js');

'use strict';

svs.eurojackpot.views.ProlongationPage = Marionette.View.extend({
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'eurojackpot',
    component: 'prolongation'
  }],
  regions: {
    prolongationRegion: '#ngProlongationRegion'
  },
  template() {
    return svs.eurojackpot.templates.prolongation_page();
  },
  onRender() {
    if (svs.eurojackpot.components.prolongation) {
      this.showChildView('prolongationRegion', new svs.eurojackpot.components.prolongation.views.Prolongation());
    }
  }
});

 })(window);